module.exports = __webpack_public_path__ + "img/4.f81c7b3c.jpg";